import { defineStore } from 'pinia';

interface pageConditions {
    url: string;
    combinedUrl: string;
    type: string;
    conditions: any;
}

type conditionsOrigin = 'overlayHeatmap' | null;
interface State {
    pageConditions: pageConditions | null;
    origin: conditionsOrigin;
}

export const useConditionsStore = defineStore('heatmap', {
    state: (): State => {
        return {
            pageConditions: null,
            origin: null
        };
    },
    getters: {},
    actions: {
        updatePageConditions(origin: conditionsOrigin, data: pageConditions | null = null) {
            this.pageConditions = data;
            this.origin = origin;
        }
    }
});
